// import BoxMe from "./boxMe";

const BoxesSec = (props) => {


    const boxInfo = props.boxInfo;
    // console.log(boxInfo);
    var count = 0;
    const data1 = boxInfo?.map((item, index) => {
        count = count + 1;
        if (count <= 4) {
            return <div className="col-sm-4" key={index}>
                <div className="box-me">
                    <i className={`${item.fontawesome}`}></i>
                    <h6 className="title-box">{item.title}</h6>
                    <span className="num-box">{item.num}</span>
                </div>
            </div>
        } else {
            return null
        }
    })

    return (
        <div className="boxes-sec">
            <div className="row">

                {data1}

            </div>
        </div>
    )
}
export default BoxesSec;